import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClockCircleOutlined, FileAddOutlined } from '@ant-design/icons';
import CreateDocumentModal from '../components/documents/CreateDocumentModal';
import DocumentBrowser from '../components/documents/DocumentBrowser';
import '../assets/styles/documents.css';

const INSPECTION_TYPE = 'Inspection';

const HUB_PATH = '/inspections/new';
const IN_PROGRESS_PATH = '/inspections/new/in-progress';

const TILE_STYLE = {
  backgroundColor: '#f5f5f5',
  color: '#333',
  borderRadius: '8px',
  height: '100px',
  display: 'flex',
  flex: '1',
  minWidth: '120px',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
};

const ICON_STYLE = { fontSize: '24px', marginBottom: '4px' };

const LABEL_STYLE = { textAlign: 'center', fontWeight: '500', fontSize: '12px' };

const NewInspections = () => {
  const navigate = useNavigate();
  const [createOpen, setCreateOpen] = useState(false);

  const handlePick = (template) => {
    setCreateOpen(false);
    navigate(`/documents/fill/${template.id}`, {
      state: {
        templateName: template.name,
        returnTo: IN_PROGRESS_PATH,
        completedReturnTo: HUB_PATH,
        inProgressReturnTo: IN_PROGRESS_PATH,
        pageTitle: 'New Inspection',
      },
    });
  };

  const tile = (icon, label, onClick) => (
    <div className="action-card" onClick={onClick} style={TILE_STYLE}>
      {icon}
      <div style={LABEL_STYLE}>{label}</div>
    </div>
  );

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: 'flex', gap: 12 }}>
        {tile(<FileAddOutlined style={ICON_STYLE} />, 'Create', () => setCreateOpen(true))}
        {tile(<ClockCircleOutlined style={ICON_STYLE} />, 'In Progress', () =>
          navigate(IN_PROGRESS_PATH)
        )}
      </div>

      <br />

      <DocumentBrowser
        scope="inspections"
        status="completed"
        embedded
        title="Completed Inspections"
        returnTo={HUB_PATH}
        completedReturnTo={HUB_PATH}
        inProgressReturnTo={IN_PROGRESS_PATH}
        rowTitle="Inspection"
        placeholder="Search completed"
        emptyText="No completed inspections yet."
      />

      <CreateDocumentModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onPick={handlePick}
        typeName={INSPECTION_TYPE}
        title="Create Inspection"
        emptyText="You have no inspection templates available."
      />
    </div>
  );
};

export default NewInspections;
